import { getTypedState } from 'ducks/hooks'
import { Subscription } from 'ducks/types'
import { isEmpty } from 'helpers/index'
import { NewOrderMaintenanceType } from './types'

export const getNewOrderMaintenanceStep = () => (): any => {
  const { newEstimate } = getTypedState() || {}
  return newEstimate?.step || 0
}

export const getNewOrderMaintenanceValue = (type: keyof NewOrderMaintenanceType) => (): any => {
  const { newOrderMaintenance } = getTypedState()
  // if (!orderMaintenance) return null
  return newOrderMaintenance[type as keyof NewOrderMaintenanceType]
}

export const getNewOrderMaintenanceValues = () => (): NewOrderMaintenanceType => {
  const { newOrderMaintenance } = getTypedState()
  return newOrderMaintenance
}

export const getNewOrderMaintenanceToCreate = () => (): Partial<Subscription> => {
  const { newOrderMaintenance } = getTypedState()
  const { step, mobileStep, contractSigned, promo, homeownerReceives, ...rest } = newOrderMaintenance
  if (isEmpty(promo)) {
    rest.promoCode = null
  }
  return Object.fromEntries(Object.entries(rest)?.filter(([_, v]) => v));
}